// Мапинг городов к их часовым поясам
export const CITY_TIMEZONES: Record<string, string> = {
  // Казахстан (UTC+6)
  Алматы: "Asia/Almaty",
  Астана: "Asia/Almaty",
  "Нур-Султан": "Asia/Almaty",
  Шымкент: "Asia/Almaty",
  Караганда: "Asia/Almaty",
  Петропавловск: "Asia/Almaty",
  Актобе: "Asia/Almaty",
  Павлодар: "Asia/Almaty",
  "Усть-Каменогорск": "Asia/Almaty",
  Семей: "Asia/Almaty",
  Атырау: "Asia/Almaty",
  Костанай: "Asia/Almaty",
  Кызылорда: "Asia/Almaty",
  Уральск: "Asia/Almaty",
  Тараз: "Asia/Almaty",
  Темиртау: "Asia/Almaty",
  Туркестан: "Asia/Almaty",
  Актау: "Asia/Almaty",
  Кокшетау: "Asia/Almaty",
  Талдыкорган: "Asia/Almaty",

  // Россия
  Москва: "Europe/Moscow",
  "Санкт-Петербург": "Europe/Moscow",
  Новосибирск: "Asia/Novosibirsk",
  Екатеринбург: "Asia/Yekaterinburg",
  Краснодар: "Europe/Moscow",
  Челябинск: "Asia/Yekaterinburg",
  Омск: "Asia/Omsk",
  "Ростов-на-Дону": "Europe/Moscow",
  Уфа: "Asia/Yekaterinburg",
  Красноярск: "Asia/Krasnoyarsk",
  Воронеж: "Europe/Moscow",
  Пермь: "Asia/Yekaterinburg",
  Волгоград: "Europe/Moscow",

  // Другие страны
  Ташкент: "Asia/Tashkent",
  Бишкек: "Asia/Bishkek",
  Душанбе: "Asia/Dushanbe",
  Ашхабад: "Asia/Ashgabat",
  Баку: "Asia/Baku",
  Ереван: "Asia/Yerevan",
  Тбилиси: "Asia/Tbilisi",
  Минск: "Europe/Minsk",
  Киев: "Europe/Kiev",
};

/**
 * Получить часовой пояс города по его названию
 */
export const getCityTimezone = (cityName: string): string => {
  return CITY_TIMEZONES[cityName] || "UTC";
};

/**
 * Преобразовать datetime-local в правильную дату с учетом часового пояса города
 */
export const convertDateTimeLocalToCityTime = (
  dateTimeLocal: string,
  cityName: string
): string => {
  if (!dateTimeLocal) return "";

  const timezone = getCityTimezone(cityName);

  // Создаем дату, считая что введенное время - это время в часовом поясе города
  const date = new Date(dateTimeLocal);

  // Получаем смещение часового пояса города
  const cityDate = new Date(
    date.toLocaleString("en-US", { timeZone: timezone })
  );
  const localDate = new Date(date.toLocaleString("en-US"));
  const offset = localDate.getTime() - cityDate.getTime();

  // Корректируем дату с учетом смещения
  const correctedDate = new Date(date.getTime() + offset);

  return correctedDate.toISOString();
};

/**
 * Преобразовать ISO дату в datetime-local с учетом часового пояса города
 */
export const convertCityTimeToDateTimeLocal = (
  isoDate: string,
  cityName: string
): string => {
  if (!isoDate) return "";

  const timezone = getCityTimezone(cityName);

  try {
    const date = new Date(isoDate);

    // Форматируем дату в часовом поясе города
    const cityTime = new Intl.DateTimeFormat("sv-SE", {
      timeZone: timezone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    }).format(date);

    // Возвращаем в формате YYYY-MM-DDTHH:mm
    return cityTime.replace(" ", "T");
  } catch (error) {
    console.error("Error converting city time:", error);
    return "";
  }
};

/**
 * Отформатировать дату для отображения с учетом часового пояса города
 */
export const formatDateInCityTimezone = (
  isoDate: string,
  cityName: string,
  format: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }
): string => {
  if (!isoDate) return "";

  const timezone = getCityTimezone(cityName);

  try {
    const date = new Date(isoDate);
    return new Intl.DateTimeFormat("ru-RU", {
      ...format,
      timeZone: timezone,
    }).format(date);
  } catch (error) {
    console.error("Error formatting date:", error);
    return "";
  }
};
